import '~/scripts/integrations/jquery-extended';
import 'jquery-datetimepicker';

export default (function() {
  return function() {
  }
})();
